// extracted by mini-css-extract-plugin
module.exports = {"listBox":"listBox","boxTitle":"boxTitle","boxDesc":"boxDesc","tablists":"tablists","listItme":"listItme","hideItem":"hideItem","moreButton":"moreButton"};